"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyWrapper = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../../styles");
var lessThanSmall = styles_1.BREAKPOINTS.lessThanSmall, smallAndUp = styles_1.BREAKPOINTS.smallAndUp;
var StyledWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media (", ") {\n    padding: 0 ", ";\n  }\n  @media (", ") {\n    padding: 0 ", ";\n  }\n"], ["\n  @media (", ") {\n    padding: 0 ", ";\n  }\n  @media (", ") {\n    padding: 0 ", ";\n  }\n"])), lessThanSmall, styles_1.PADDING.content.lessThanSmall.rightAndLeft, smallAndUp, styles_1.PADDING.content.smallAndUp.rightAndLeft);
var PropertyWrapper = function (_a) {
    var className = _a.className, children = _a.children;
    return react_1.default.createElement(StyledWrapper, { className: className }, children);
};
exports.PropertyWrapper = PropertyWrapper;
var templateObject_1;
